import useCapabilities, { useHasRoles } from "@/hooks/useCapabilities";
import { ROLE } from "@/providers/AuthorizationProvider/types";
import { canManageAnySectionCommittee, canManageSectionCommittee } from "./canManageSectionCommittee";

export function useCanManageSectionCommittees(sectionLegacyId?: string | null): {
  canManageCommittees: boolean;
  ready: boolean;
} {
  const isGlobalAdmin = useHasRoles([ROLE.GLOBAL_ADMIN]);
  const { loaded, sectionLegacyIds, sectionLegacyIdsLoading } = useCapabilities();

  const ready = loaded && (isGlobalAdmin || !sectionLegacyIdsLoading);

  return {
    canManageCommittees: canManageSectionCommittee({
      isGlobalAdmin,
      assignedSectionLegacyIds: sectionLegacyIds,
      sectionLegacyId
    }),
    ready
  };
}

export function useCanManageAnySectionCommittees(): {
  canManageAnySection: boolean;
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
  ready: boolean;
} {
  const isGlobalAdmin = useHasRoles([ROLE.GLOBAL_ADMIN]);
  const { loaded, sectionLegacyIds, sectionLegacyIdsLoading } = useCapabilities();
  const ready = loaded && (isGlobalAdmin || !sectionLegacyIdsLoading);

  return {
    canManageAnySection:
      ready && canManageAnySectionCommittee({ isGlobalAdmin, assignedSectionLegacyIds: sectionLegacyIds }),
    isGlobalAdmin,
    assignedSectionLegacyIds: sectionLegacyIds,
    ready
  };
}
